import React from "react";

const MailIcon = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.79766 3.20117C2.13516 3.20117 1.59766 3.73867 1.59766 4.40117C1.59766 4.77867 1.77516 5.13367 2.07766 5.36117L7.27766 9.26117C7.70516 9.58117 8.29016 9.58117 8.71766 9.26117L13.9177 5.36117C14.2202 5.13367 14.3977 4.77867 14.3977 4.40117C14.3977 3.73867 13.8602 3.20117 13.1977 3.20117H2.79766ZM1.59766 6.50117V11.2012C1.59766 12.0837 2.31516 12.8012 3.19766 12.8012H12.7977C13.6802 12.8012 14.3977 12.0837 14.3977 11.2012V6.50117L9.43766 10.2212C8.58516 10.8612 7.41016 10.8612 6.55766 10.2212L1.59766 6.50117Z"
      fill="white"
    />
  </svg>
);

export default MailIcon;
